import * as Animate from "react-reveal";

const pillars = [
  {
    number: "01",
    title: "Live expert classes",
    desc:
      "Practitioners teach through guided sessions built around the realities of modern work.",
  },
  {
    number: "02",
    title: "Projects that mirror the job",
    desc:
      "Every pathway turns learning into practical work, feedback and evidence of capability.",
  },
  {
    number: "03",
    title: "Your learning environment",
    desc:
      "A branded, trackable learning space helps your team access content and monitor progress.",
  },
];

const DeliveryApproachSection = () => {
  return (
    <section className="bg-white py-16 md:py-20 lg:py-24 px-4">
      <div className="container mx-auto">
        <Animate.Fade bottom>
          <p className="flex items-center font-poppins gap-3 text-primary text-sm font-extrabold tracking-widest uppercase mb-6">
            <span className="w-8 h-1 rounded-full bg-secondary inline-block"></span>
            The delivery experience
          </p>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start mb-12 lg:mb-14">
            <h2 className="lg:col-span-2 text-3xl md:text-4xl leading-tight font-poppins font-black max-w-xl tracking-[-0.03em] text-primary">
              Give employees more than access to content.
            </h2>
            <p className="text-gray text-base font-poppins leading-relaxed lg:pt-2">
              People build capability when instruction, practice, feedback and
              accountability work together.
            </p>
          </div>
        </Animate.Fade>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {pillars.map((pillar) => (
            <Animate.Fade bottom key={pillar.number}>
              <article className="h-full bg-white border border-hire-line rounded-2xl shadow-course-card p-7">
                <span className="w-9 h-9 rounded-full grid place-items-center font-poppins text-sm font-extrabold text-primary bg-secondary mb-20">
                  {pillar.number}
                </span>
                <h3 className="font-poppins font-bold text-xl text-primary mb-3">
                  {pillar.title}
                </h3>
                <p className="text-gray font-poppins text-sm leading-relaxed m-0">
                  {pillar.desc}
                </p>
              </article>
            </Animate.Fade>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DeliveryApproachSection;
